import React, { useEffect } from 'react';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import { useDispatch, useSelector } from 'react-redux';
import { fetchJobsForCompany } from '../../../redux/JobSlice/jobSlice';

const CLCompanyProfile = ({ companyData }) => {
    const dispatch = useDispatch();
    const { companyJobs } = useSelector((state) => state.jobs);

    useEffect(() => {
        if (companyData?._id) {
            dispatch(fetchJobsForCompany(companyData._id));
        }
    }, [companyData?._id, dispatch]);

    // useEffect(() => {
    //     console.log("Fetching jobs for company ID:", companyData?._id);
    //     if (companyData?._id) {
    //         dispatch(fetchJobsForCompany(companyData._id));
    //     }
    // }, [companyData?._id, dispatch]);

    if (!companyData) return null;

    return (
        <div className="w-full max-w-md mx-auto flex flex-col border-2 rounded-md">
            {/* Company Profile */}
            <div className='flex flex-rows justify-between border-b px-4 py-3 sm:px-6 gap-2'>
                <p>Company Profile</p>
                <MoreHorizIcon className='bg-gray-200 hover:bg-gray-300 cursor-pointer' />
            </div>

            <div className="flex flex-col items-center gap-2 border-b min-w-0 px-4 py-3 sm:px-6">
                <img
                    src={companyData?.companyLogo || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2TrFqRb5JEPJ8mifqJapzxmZCNqnghbgNh6U2&s=0"}
                    alt="Company logo"
                    className="rounded-full shrink-0 w-[50px] h-[50px]"
                />
                <p className="font-dmsans font-bold text-[#5A6474] text-left break-words">
                    {companyData?.name || "Not available"}
                </p>
                <p className="font-dmsans font-normal text-xs text-[#757D8A] text-left break-words">
                    28 members
                </p>
            </div>
            <div className='flex flex-col items-start gap-4 px-4 py-3 sm:px-6 border-b'>
                <div className='flex flex-col'>
                    <p className="font-dmsans font-normal text-[#5A6474] text-xs text-left break-words">
                        HEADQUARTERS
                    </p>
                    <p className="font-dmsans font-medium text-[#5A6474] text-sm text-left break-words">
                        {companyData?.hqLocation}
                    </p>
                </div>
                <div className='flex flex-col'>
                    <p className="font-dmsans font-normal text-[#5A6474] text-xs text-left break-words">
                        CONTACT
                    </p>
                    <p className="font-dmsans font-medium text-[#5A6474] text-sm text-left break-words">
                        {companyData?.email}
                    </p>
                </div>
                <div className='flex flex-col'>
                    <p className="font-dmsans font-normal text-[#5A6474] text-xs text-left break-words">
                        DESCRIPTION
                    </p>
                    <p className="font-dmsans font-medium text-[#5A6474] text-sm text-left break-words">
                        {companyData?.description}
                    </p>
                </div>
            </div>


            {/* Job Listings Section */}
            <div className='flex flex-col'>
                <div className='px-4 py-3 sm:px-6 border-b'>
                    <p className="font-dmsans font-medium text-[#5A6474] text-sm">Open Positions ({companyJobs.length})</p>
                </div>
                <div className='flex flex-col'>
                    {companyJobs.map((job, index) => (
                        <div key={index} className={`px-4 py-3 sm:px-6 hover:bg-gray-50 cursor-pointer ${index !== companyJobs.length - 1 ? 'border-b' : ''}`}>
                            <div className='flex flex-col gap-2'>
                                <div className='flex flex-col'>
                                    <p className="font-dmsans font-medium text-[#5A6474] text-sm text-left">
                                        {job.jobPosition}
                                    </p>
                                    <p className="font-dmsans font-normal text-xs text-[#757D8A] text-left">
                                        {job.jobLocation} • {job.jobType}
                                    </p>
                                </div>
                                <div className='flex justify-between items-center'>
                                    <p className="font-dmsans font-medium text-xs text-green-600">
                                        {job.jobMinSalary && job.jobMaxSalary
                                            ? `$${job.jobMinSalary} - $${job.jobMaxSalary}`
                                            : "Not Listed"}
                                    </p>
                                    <p className="font-dmsans font-normal text-xs text-[#757D8A]">
                                        {job.postedAt}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CLCompanyProfile;